import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

import { EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED } from './useConfluenceStandardToPremiumExperiment';
import UseConfluenceStandardToPremiumExperimentQuery, {
	type useConfluenceStandardToPremiumExperimentQuery$data,
	type useConfluenceStandardToPremiumExperimentQuery$variables,
} from './__generated__/useConfluenceStandardToPremiumExperimentQuery.graphql';

export async function preloadUseConfluenceStandardToPremiumExperimentQuery() {
	const { isLoggedIn, accessStatus } = getPreloaderFnContext();

	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	if (!isLoggedIn || !isLicensed) {
		return;
	}

	return query<
		useConfluenceStandardToPremiumExperimentQuery$data,
		useConfluenceStandardToPremiumExperimentQuery$variables
	>({
		query: UseConfluenceStandardToPremiumExperimentQuery,
		variables: {
			key: [EDITION_AWARENESS_STANDARD_TO_PREMIUM_EXPERIMENT_PILL_DISMISSED],
		},
	});
}
